@let isLg = viewportSelectors.isLgAndUp | select;
@let isSm = viewportSelectors.isSm | select;

<mat-sidenav-container class="mt-7">
  <mat-sidenav #sidenav position="start">
    <ng-container *ngTemplateOutlet="searchFilters"/>
  </mat-sidenav>

  <mat-sidenav-content class="flex flex-col lg:flex-row gap-5 lg:gap-7 pb-7 px-4 lg:px-10">
    @if (isLg) {
      <!-- Filters Section (Large sized screen/window) -->
      <div class="w-1/4 min-w-[18.75rem] shrink-0 grow">
        <ng-container *ngTemplateOutlet="searchFilters"/>
      </div>
    }

    <!-- Search Results Section -->
    <div class="w-full lg:w-3/4">
      <mat-card>
        <mat-card-title class="pb-0">Search Results: {{ routerSelectors.queryParamValue('q') | select:'' }}</mat-card-title>
        <mat-card-content class="pt-0 px-2 md:px-4">
          @if (!isLg) {
            <!-- Filters & Sort Row (Medium and smaller screen/window) -->
            <div class="flex flex-row py-2 mx-2">
              <mx-text-button startIcon="filter_list" label="Show Filters" (click)="sidenav.toggle()"/>
            </div>
          }
          <!-- Usually we use mat-chip-set with mat-chip for static chips and mat-chip-listbox with mat-chip-option for forms,
             but here, we use mat-chip-listbox so that click targets are allowed in the container but regular mat-chips,
             since only the remove button is clickable-->
          @let filters = activeFilterOptions | select:[];
          <mat-chip-listbox class="mx-2">
            @for (filter of filters; track $index) {
              <mat-chip class="border" color="background">
                <div class="flex items-center mr-[-0.75rem]">
                  {{ filter.displayName }}
                  <mx-icon-button icon="close" color="on-surface-variant" iconClasses="mat-icon-size-5" buttonClasses="size-[2rem] p-[0.375rem]"
                                  (click)="removeFilter(filter)"/>
                </div>
              </mat-chip>
            }
            @if (isPopulatedArray(filters)) {
              <mx-text-button (click)="removeAllFilters()" label="Clear Filters"/>
            }
          </mat-chip-listbox>
          <mx-table [ngClass]="{'no-horizontal-cell-padding': isSm}" [tableDefinition]="tableDefinition"/>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #searchFilters>
  <px-catalog-filters/>
</ng-template>
